var _feGaussianBlur;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShapeSquareHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 114,
    viewBox: "0 0 30.1625 30.162501",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs15368"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter24111",
    x: -0.096000001,
    width: 1.192,
    y: -0.096000001,
    height: 1.192
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.79375,
    id: "feGaussianBlur24113"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-266.83749)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1,
      filter: "url(#filter24111)"
    },
    id: "rect4518-85-9-8-1-0-7",
    width: 19.84375,
    height: 19.84375,
    x: -1.845581e-7,
    y: 277.15625,
    transform: "matrix(1.2751678,0,0,1.2751678,2.4291949,-84.154042)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapeSquareHighlight);
export default __webpack_public_path__ + "static/media/icon-shape-square-highlight.1d1fc60edca28cef6c376eceb4d223cf.svg";
export { ForwardRef as ReactComponent };